import { ReviewStatus } from "@models/job";

export type ReviewStatusFilter = "all" | ReviewStatus;

export const STATUS_FILTERS: ReviewStatusFilter[] = [
  "all",
  ReviewStatus.Pending,
  ReviewStatus.Accepted,
  ReviewStatus.Rejected,
  ReviewStatus.Corrected,
  ReviewStatus.Failed,
];

export const triggerJsonDownload = (
  filename: string,
  data: unknown,
): void => {
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: "application/json",
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};

/**
 * Trigger a browser download of a remote URL (e.g. a presigned S3 link).
 * The `download` hint is best-effort — cross-origin S3 responses force the
 * filename via their `Content-Disposition` header instead.
 */
export const triggerUrlDownload = (url: string, filename: string): void => {
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = "noopener";
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};
